import React from 'react';
import { DashlineSeparator } from '../../../../common/CommonStyle';
import { StepDescription } from '../../SelfieVerificationStyle';
import { Headline } from '../../../JoinStyle';
import MagicQRCode from './MagicQRCode';

const QRCodeContent: React.FC<{ isJoinFlow: boolean }> = ({ isJoinFlow }) => {
  return (
    <>
      <Headline>{`We can't find a camera on this device`}</Headline>
      {/* @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389 */}
      <StepDescription style={{ margin: '10px 0 0 0' }}>
        To continue, use another device to scan the QR code and complete your selfie verification process.
      </StepDescription>
      <DashlineSeparator style={{ width: '100%' }} />
      <MagicQRCode isJoinFlow={isJoinFlow} />
    </>
  );
};

export default QRCodeContent;
